var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeSheetActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 3.2H18.6V2.1C18.6 1.44 18.16 1 17.5 1C16.84 1 16.4 1.44 16.4 2.1V3.2H7.6V2.1C7.6 1.44 7.16 1 6.5 1C5.84 1 5.4 1.44 5.4 2.1V3.2H4.3C2.43 3.2 1 4.63 1 6.5V7.71043H23V6.5C23 4.63 21.57 3.2 19.7 3.2ZM1 19.7C1 21.57 2.43 23 4.3 23H19.7C21.57 23 23 21.57 23 19.7V9.5H1V19.7ZM17.5 12C18.16 12 18.6 12.44 18.6 13.1C18.6 13.76 18.16 14.2 17.5 14.2C16.84 14.2 16.4 13.76 16.4 13.1C16.4 12.44 16.84 12 17.5 12ZM17.5 16.4C18.16 16.4 18.6 16.84 18.6 17.5C18.6 18.16 18.16 18.6 17.5 18.6C16.84 18.6 16.4 18.16 16.4 17.5C16.4 16.84 16.84 16.4 17.5 16.4ZM12 12C12.66 12 13.1 12.44 13.1 13.1C13.1 13.76 12.66 14.2 12 14.2C11.34 14.2 10.9 13.76 10.9 13.1C10.9 12.44 11.34 12 12 12ZM12 16.4C12.66 16.4 13.1 16.84 13.1 17.5C13.1 18.16 12.66 18.6 12 18.6C11.34 18.6 10.9 18.16 10.9 17.5C10.9 16.84 11.34 16.4 12 16.4ZM6.5 12C7.16 12 7.6 12.44 7.6 13.1C7.6 13.76 7.16 14.2 6.5 14.2C5.84 14.2 5.4 13.76 5.4 13.1C5.4 12.44 5.84 12 6.5 12ZM6.5 16.4C7.16 16.4 7.6 16.84 7.6 17.5C7.6 18.16 7.16 18.6 6.5 18.6C5.84 18.6 5.4 18.16 5.4 17.5C5.4 16.84 5.84 16.4 6.5 16.4Z",
    fill: "#F37D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSheetActive);
export default __webpack_public_path__ + "static/media/time_sheet_active.9d865c0e6a34d7fcc44f195939c43d79.svg";
export { ForwardRef as ReactComponent };